/* eslint-disable import/no-unresolved */
export default [
  {
    path: '/project/:alias/:projectAlias/issue',
    component: () => import('./pages/page-project-issues'),
    name: 'project-issues'
  },
  {
    path: '/project/:alias/:projectAlias/issue/create',
    component: () => import('./pages/page-project-issue-form'),
    name: 'project-issue-add'
  },
  {
    path: '/project/:alias/:projectAlias/issue/:issueId/edit',
    component: () => import('./pages/page-project-issue-form'),
    name: 'project-issue-edit'
  },
  {
    path: '/project/:alias/:projectAlias/issue/:issueId',
    component: () => import('./pages/page-project-issue'),
    name: 'project-issue'
  }
];
